import { Pipe, PipeTransform } from '@angular/core';

import { ProductShortName } from '@app/enums/product-shortname.enum';
import { SubscriptionType } from '@app/enums/subscription-type.enum';

@Pipe({
  name: 'subscriptionIcon',
  standalone: false,
})
export class SubscriptionIconPipe implements PipeTransform {
  /**
   * Transform and return subscription icon string to subscription icon on card header
   * @param subscriptionType - subscription type params to be transformed
   * @returns - transformed subscription name string
   */
  public transform(subscriptionType: string): string {
    switch (subscriptionType) {
      case SubscriptionType.AI_ESSENTIAL_SUBSCRIPTION:
        return 'info-icon';
      case SubscriptionType.GENESYS_ENGAGE_SUBSCRIPTION:
        return ProductShortName.GENESYS_ENGAGE;
      case SubscriptionType.POINTILLIST_SUBSCRIPTION:
        return ProductShortName.POINTILLIST;
      case SubscriptionType.PURECONNECT_SUBSCRIPTION:
        return ProductShortName.PURE_CONNECT;
      case SubscriptionType.GENESYS_CLOUD_SUBSCRIPTION:
        return ProductShortName.GENESYS_CLOUD;
      default:
        // Default return empty or no icon string
        return '';
    }
  }
}
